import React from 'react';
import { connect } from 'react-redux';
import { getList, remove } from '../Actions/channel';
import ListChannel from '../Components/Channel/List';
import Routes from '../Shared/routes';
import Channel from '../Entities/Channel';

interface IProps {
    isLoading: boolean;
    error: string;
    list: Channel[];
    getChannels: () => void;
    remove: (nId: number) => void;
    history: any;
}

interface IState {
    isLoading: boolean;
    isLogin: boolean;
}

class ChannelListPage extends React.Component<IProps, IState> {

    async componentDidMount() {
        if (!this.props.list.length) {
            await this.props.getChannels();
        }
        else {
            this.forceUpdate();
        }
    }

    onRemove = async (nId: number) => {
        await this.props.remove(nId);
        this.props.history.goBack();
    }

    onAdd = () => {
        this.props.history.push(Routes.CHANNEL_CREATE);
    }

    render() {
        const { error, isLoading, list} = this.props;
        return (
            <ListChannel
                error={error}
                isLoading={isLoading}
                list={list}
                add={this.onAdd}
                remove={this.onRemove}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        getChannels: () => dispatch(getList()),
        remove: (nId: number) => dispatch(remove(nId))
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.channel.isLoading,
        list: state.channel.list,
        error: state.channel.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(ChannelListPage);
